<template>
  <div id="app">
    <div class="menu-box">
      <div v-if="screenWidth<=750" class="m_head">
        <img src="../assets/logo.png" class="logo">
        <img src="../assets/list.png" class="list" @click="menuClick">
      </div>
      <div class="menu-item" v-else>
        <div @click="choiceMenu(0)" :class="(menuIndex===0)?'choice':''">{{$t('menu_1')}}</div>
        <div @click="choiceMenu(1)" :class="(menuIndex===1)?'choice':''">{{$t('menu_2')}}</div>
        <div @click="choiceMenu(2)" :class="(menuIndex===2)?'choice':''">{{$t('menu_3')}}</div>
        <div @click="choiceMenu(3)" :class="(menuIndex===3)?'choice':''">{{$t('menu_4')}}</div>
        <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice':''">{{$t('menu_5')}}</div>
        <div @click="choiceMenu(5)" :class="(menuIndex===5)?'choice':''">{{$t('menu_6')}}</div>
        <div @click="choiceMenu(6)" :class="(menuIndex===6)?'choice':''">{{$t('menu_7')}} </div>

        <div class="show_list">
          <span>Language</span>
          <ul class="move_list">
            <li @click="$i18n.locale = 'th'">แบบไทย</li>
            <li @click="$i18n.locale = 'mk'">မြန်မာ</li>
          </ul>
        </div>
      </div>
      <transition name="bounce">
        <div class="menu-item" v-if="showMenu">
          <div @click="choiceMenu(0)" :class="(menuIndex===0)?'choice':''">{{$t('menu_1')}}</div>
          <div @click="choiceMenu(1)" :class="(menuIndex===1)?'choice':''">{{$t('menu_2')}}</div>
          <div @click="choiceMenu(2)" :class="(menuIndex===2)?'choice':''">{{$t('menu_3')}}</div>
          <div @click="choiceMenu(3)" :class="(menuIndex===3)?'choice':''">{{$t('menu_4')}}</div>
          <div @click="choiceMenu(4)" :class="(menuIndex===4)?'choice':''">{{$t('menu_5')}}</div>
          <div @click="choiceMenu(5)" :class="(menuIndex===5)?'choice':''">{{$t('menu_6')}}</div>
          <div @click="choiceMenu(6)" :class="(menuIndex===6)?'choice':''">{{$t('menu_7')}} </div>
        </div>
      </transition>
    </div>
    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app_name">
        <div class="title">{{$t('banner_1')}}</div>
        <div class="title-content">
          {{$t('banner_2')}}
        </div>
      </div>
    </div>
    <div class="step-box" id='step' ref="step">
      <div class="title">{{$t('step_1')}}</div>
      <div class="step-content">
        <div class="step-box-list">
          <img src="../assets/list-1.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{$t('step_2')}}</p>
        </div>
        <div class="step-box-list">
          <img src="../assets/list-2.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{$t('step_3')}}</p>
        </div>
        <div class="step-box-list">
          <img src="../assets/list-3.png" class="step-img">
          <!-- <p class="text-title">Need a CURP</p> -->
          <p class="text">{{$t('step_4')}}</p>
        </div>
      </div>
    </div>
    <div class="product" id="product" ref="product">
      <div class="title">{{$t('product_1')}}</div>
      <div class="product-content">
        <img src="../assets/product.png" class="product-img">
        <div class="product-item-text">
          <div>{{$t('product_2')}}</div>
          <div>{{$t('product_3')}}</div>
          <div>{{$t('product_4')}}</div>
          <div>{{$t('product_5')}}</div>
        </div>

      </div>
    </div>

    <div class="user" id='user' ref="user">
      <div class="title">{{$t('user_1')}}</div>
      <div class="user-content">
        <div class="user-text-box">
          <div>{{$t('user_2')}}</div>
          <div>{{$t('user_3')}}</div>
          <div>{{$t('user_4')}}</div>
        </div>
        <img src="../assets/user.png" class="user-img">
      </div>
    </div>

    <div class="about" id='about' ref="about">
      <div class="title">{{$t('about_1')}}</div>
      <div class="about-content">
        <br> {{$t('about_2')}}
        <br> {{$t('about_3')}}
      </div>
    </div>

    <div class="privacy-box" id='privacy' ref="privacy">
      <div class="privacy-content-box " :class="(isMore)?'bottomhig':'maxhight'">
        <privacy></privacy>
      </div>
      <div class="get-more" @click="isMore = true" v-if="!isMore">
        <img src="../assets/get-more.png" alt="">
      </div>
    </div>

    <div class="footer" id='footer' ref="footer">
      <div class="title">{{$t('footer_1')}} </div>
      <div class="footer-content">
        <div class="time-box">
          <img src="../assets/time.png" class="time-img">
          <div class="time">
            {{$t('footer_2')}}
          </div>
        </div>
        <div class="mail-box">
          <img src="../assets/mail.png" class="mail-img">
          <div class="mail">{{$t('footer_3')}}</div>
        </div>
        <div class="address-box">
          <img src="../assets/address.png" class="address-img">
          <div class="address">
            {{$t('footer_4')}}
          </div>
        </div>
      </div>
      <p class="bottom-text">© Copyright 2022 {{$t('footer_5')}}.</p>
    </div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data () {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let lag = this.$route.query.lag
    if (lag == 'th' || lag == 'mk') {
      this.$i18n.locale = lag
    }
  },
  methods: {
    choiceMenu (index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        case 3: document.getElementById("user").scrollIntoView(); break;
        case 4: document.getElementById("about").scrollIntoView(); break;
        case 5: document.getElementById("privacy").scrollIntoView(); break;
        case 6: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>


<style lang="less"  scoped>
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
